<template>
    <v-card elevation="0">
        <v-card-title>Canales de venta habilitados</v-card-title>
        <v-card-text>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-checkbox
                        label="Web"
                        color="secondary"
                        v-model="webEnabled"
                        name="salesChannelWeb"
                    ></v-checkbox>
                    <v-autocomplete
                        v-if="webEnabled"
                        label="Modos de entrega"
                        color="secondary"
                        :value="salesChannelsConfig.web.modes"
                        @input="salesChannelsConfig.updateModesWeb($event)"
                        chips
                        :items="['Delivery', 'Take Away']"
                        multiple
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-checkbox
                        label="Mostrador"
                        color="secondary"
                        v-model="mostradorEnabled"
                        name="salesChannelMostrador"
                    ></v-checkbox>
                    <v-autocomplete
                        v-if="mostradorEnabled"
                        label="Modos de entrega"
                        color="secondary"
                        :value="salesChannelsConfig.mostrador.modes"
                        @input="salesChannelsConfig.updateModesMostrador($event)"
                        chips
                        :items="['Delivery', 'Take Away']"
                        multiple
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-checkbox
                        label="Salón"
                        color="secondary"
                        v-model="salonEnabled"
                        name="salesChannelSalon"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import SalesChannelsConfig from './SalesChannelsConfig'

    export default {
        name: 'SalesChannelsConfigComponent',
        props: {
            salesChannelsConfig: {
                type: SalesChannelsConfig,
                required: true
            }
        },
        computed: {
            webEnabled: {
                get() {
                    return this.salesChannelsConfig.web.enabled
                },
                set(value) {
                    this.salesChannelsConfig.updateEnabledWeb(value)
                    if(!value) this.salesChannelsConfig.updateModesWeb([])
                }
            },
            mostradorEnabled: {
                get() {
                    return this.salesChannelsConfig.mostrador.enabled
                },
                set(value) {
                    this.salesChannelsConfig.updateEnabledMostrador(value)
                    if(!value) this.salesChannelsConfig.updateModesMostrador([])
                }
            },
            salonEnabled: {
                get() {
                    return this.salesChannelsConfig.salon.enabled
                },
                set(value) {
                    this.salesChannelsConfig.updateEnabledSalon(value)
                }
            }
        }
    }
</script>

<style scoped>

</style>